var map = {
	"./App.vue": "Qjx5",
	"./components/AddToCartBtn.vue": "gMtK",
	"./components/BackToTop.vue": "vCPo",
	"./components/CartItem.vue": "Fttg",
	"./components/CategoryPieChart.vue": "n8Qf",
	"./components/Datepicker.vue": "a50C",
	"./components/Footer.vue": "HVGL",
	"./components/Header.vue": "gBat",
	"./components/HeaderCart.vue": "DkBP",
	"./components/LanguageSwitcher.vue": "4qBS",
	"./components/MultiUploadInput.vue": "tOA/",
	"./components/OrderProductForm.vue": "dTSc",
	"./components/OrderProductItem.vue": "dh5Z",
	"./components/ReceiptApproveBtn.vue": "Yiip",
	"./components/ReceiptPreviewBtn.vue": "nMnX",
	"./components/UploadInput.vue": "dqDN",
	"./views/CartPage.vue": "IUy/",
	"./views/Homepage.vue": "9Pj/",
	"./views/OrderDetailPage.vue": "EHI2",
	"./views/OrderTrackingPage.vue": "yDQV",
	"./views/PrivacyPage.vue": "s4xR",
	"./views/ProductDetailPage.vue": "490F",
	"./views/SuccessPage.vue": "S8uL",
	"./views/TermsPage.vue": "0LU0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "+fAT";